<template>
    <div id="app" class="fadeup">
        <router-view></router-view>
    </div>
</template>

<script>
export default {}
</script>
